//Using the react library
import React from "react";
//Using the react library:
import { useEffect, useState } from "react";
//API Middle man
import useApi from "../utils/UseAPI";
// React loading spinner
import Spinner from 'react-bootstrap/Spinner';

function DataGuideList() {

    const { error, processing, getRequest } = useApi();
    const [content, setContent] = useState([]);
    
    
    useEffect(() => {

        const fetchLinks = async () => {
            const [data, status] = await getRequest(null, "cmhc/data-guide");
            if (status == 200) {
                setContent(data.data)
            }
            else {
                console.log(error)
            }
        };
        fetchLinks();
    }, []);

    return (
        <>
            <div className="col-md-4 col-md-3">          
                    {/* Return List */}
                    <select className="form-select" onChange={(e) =>{
                        window.location = e.target.value;
                    }}>
                    <option>Select a Report</option>

                        {
                            processing ? <Spinner animation="border" variant="success" /> : content.filter(x => x.reportName != "DSG_CMHC_G" && x.reportName != "DSG_CMHC_ICD9_MR" && x.reportName != "DSG_CMHC_Med_XWLK_OC").map((data, index) => {
                                return (
                                    <option value={"https://dbhdid.ky.gov/DataReports/Reports.aspx?r="+data.reportName+"&x=rdl"} key={index} className="form-select">{data.reportDesc}</option>
                                )
                            })
                        }
                    </select>
            </div>
        </>
    );
}

export default DataGuideList;